import RouterSection from '@/layout/components/RouterSection'

export default {
  path: '/example',
  name: 'example_home',
  component: RouterSection,
  redirect: { name: 'Echart' },
  children: [
    {
      path: 'highchart',
      name: 'Highchart',
      component: () => import('@/views/example/Highchart.vue')
    },
    {
      path: 'web-editor',
      name: 'WebEditor',
      component: () => import('@/views/example/WebEditor.vue')
    },
    {
      path: 'iframe',
      name: 'Iframe',
      component: () => import('@/views/example/Iframe.vue')
    },
    // {
    //   path: 'echart',
    //   name: 'Echart',
    //   component: () => import('@/views/example/Echart.vue')
    // },
    {
      path: 'fileupload',
      name: 'FileUpload',
      component: () => import('@/views/example/FileUpload.vue')
    },
    {
      path: 'dialog',
      name: 'DialogSet',
      component: () => import('@/views/example/DialogSet.vue')
    },
    {
      path: 'window-popup',
      name: 'WindowPopup',
      component: () => import('@/components/dialogSet/WindowPopup.vue')
    }
  ]
}
